import { useMutation } from "@apollo/client";
import { XMarkIcon } from "@heroicons/react/24/outline";

import { Button, IconButton, Modal } from "../../../../../../../components/ui";
import { DELETE_CONSIGNMENT_WORK } from "../../../../../../../graphql/mutation/ConsignmentWork";
import useUser from "../../../../../../../hooks/useUser";

const Actions = (props = {}) => {
  const { id, consignmentId, instanceId } = props;
  const { hasPermission } = useUser();
  const [deleteConsignmentWork, { loading, error, reset }] = useMutation(
    DELETE_CONSIGNMENT_WORK,
    { refetchQueries: ["FetchConsignment"] },
  );

  const modalProps = {
    title: "Are you sure?",
    scale: "sm",
    description: `Would you like to delete this consignment work?`,
    closeOnBackdrop: true,
    disabled: !hasPermission("ADD_CONSIGNMENT_ITEM"),
    body: ({ closeModal }) => {
      const handleDelete = async () => {
        await deleteConsignmentWork({
          variables: {
            input: {
              id,
              consignmentId,
              instanceId,
            },
          },
          update: (cache, { data }) => {
            const { deleteConsignmentWork: { success } = {} } = data;
            if (success) {
              cache.evict({
                id: cache.identify({
                  __typename: "ConsignmentWork",
                  id,
                }),
              });
            }
          },
        });

        reset();
        closeModal();
      };

      return (
        <>
          {error?.message && (
            <div className="my-3 text-red-500">{error.message}</div>
          )}
          <div className="mt-4 flex justify-end">
            <Button
              label={loading ? "Deleting" : "Delete"}
              disabled={loading}
              onClick={handleDelete}
            />
          </div>
        </>
      );
    },
  };

  if (!id) return null;

  return (
    <div className="user-list-actions flex text-right text-sm font-medium">
      <div className="grid">
        <Modal {...modalProps}>
          <IconButton
            variant="clean"
            title="Delete Work"
            disabled={!hasPermission("ADD_CONSIGNMENT_ITEM")}
          >
            <XMarkIcon
              className={`h-4 w-4 cursor-pointer text-gray-400`}
              onClick={() => {
                reset();
              }}
            />
          </IconButton>
        </Modal>
      </div>
    </div>
  );
};

export default Actions;
